import { createFollowUpRequest } from './createFollowUpRequest';
import { deleteFollowUpRequest } from './deleteFollowUpRequest';
import { fetchFollowUpRequest } from './fetchFollowUpRequest';
import { fetchFollowUpRequests } from './fetchFollowUpRequests';

export const followUpRequestService = {
  fetchFollowUpRequest,
  fetchFollowUpRequests,
  createFollowUpRequest,
  deleteFollowUpRequest,
};
